import { __assign, __read, __spreadArray } from "tslib";
export function isSubschemaConfig(value) {
    return Boolean(value === null || value === void 0 ? void 0 : value.schema);
}
export function cloneSubschemaConfig(subschemaConfig) {
    var newSubschemaConfig = __assign(__assign({}, subschemaConfig), { transforms: subschemaConfig.transforms != null ? __spreadArray([], __read(subschemaConfig.transforms)) : undefined });
    if (newSubschemaConfig.merge != null) {
        newSubschemaConfig.merge = __assign({}, subschemaConfig.merge);
        Object.keys(newSubschemaConfig.merge).forEach(function (typeName) {
            var mergedTypeConfig = (newSubschemaConfig.merge[typeName] = __assign({}, subschemaConfig.merge[typeName]));
            if (mergedTypeConfig.entryPoints != null) {
                mergedTypeConfig.entryPoints = mergedTypeConfig.entryPoints.map(function (entryPoint) { return (__assign({}, entryPoint)); });
            }
            if (mergedTypeConfig.fields != null) {
                var fields_1 = (mergedTypeConfig.fields = __assign({}, mergedTypeConfig.fields));
                Object.keys(fields_1).forEach(function (fieldName) {
                    fields_1[fieldName] = __assign({}, fields_1[fieldName]);
                });
            }
        });
    }
    return newSubschemaConfig;
}
//# sourceMappingURL=subschemaConfig.js.map